module.exports = __webpack_public_path__ + "5355e9aeac1609a30b2594877678c659.svg";